import { InputNumber } from 'antd';
import ReactInputMask from 'react-input-mask';
import { formatDate, normalizeDate } from '../../../../utils';

const DateInput = ({ Form, rules, data, parentKey }) => {
  return (
    <Form.Item
      name={[parentKey, data.name]}
      label={data.title}
      rules={rules[data.name]}
      className='form_group'
    >
      <ReactInputMask className='form_control date-input' placeholder='MM/DD/YYYY' mask="99/99/9999" name={data.name} />
    </Form.Item>
  );
};

export default DateInput;
